export const getFirstChar = (text: string): string => {
  if ('Segmenter' in Intl) {
    const segments = [...new Intl.Segmenter().segment(text)]
    return segments[0]?.segment || ''
  }
  return text.charAt(0)
}
